// extracted by mini-css-extract-plugin
module.exports = {"container":"card-slider_container__28BwD"};